import { Lead } from "shared/topchef.types";
import PublicLeadContent from "../public-lead-content/PublicLeadContent"

type LeadContentProps = {
  lead: Lead;
};

const LeadContent = ({lead }: LeadContentProps) => {

  return (
      <>
        <PublicLeadContent publicLead={lead} />

        <div id="brief_details_contact" className="p-3 bg-light mb-4 rounded">
                <h5 className="mb-2">Informations Client</h5>
                <div className="row g-2">
                    <div className="col-md-6">
                        <strong>Email : </strong>
                        <a id="brief_contact_email" href={'mailto:'+lead.contactEmailAddress}>{lead.contactEmailAddress}</a>
                    </div>
                    <div className="col-md-6">
                        <strong>Tél. mobile : </strong>
                        <a id="brief_contact_tel" href={'tel:'+ lead.contactMobilePhone}>{lead.contactMobilePhone}</a>
                    </div>
                    <div className="col-md-6">
                        <strong>Entreprise : </strong>
                        <span id="brief_company">{lead.contactCompany}</span>
                    </div>
                    <div className="col-md-6">
                        <strong>Nom & Prénom : </strong>
                        <span id="brief_contact_name">{lead.contactName}</span>
                    </div>
                    <div className="col-md-6">
                        <strong>Tél. fixe : </strong>
                        <a id="brief_contact_tel_fix" href={'tel:'+ lead.contactLandlinePhone}>{lead.contactLandlinePhone}</a>
                    </div>
                </div>
            </div>
      </>
  );

}

export default LeadContent;
